import classNames from "classnames";
import React, { useCallback } from "react";

import styles from "./style.module.css";

const ModalButtonSecondary = ({ children, className, disabled, onClick, dataTestId }) => {
  const onButtonClick = useCallback(
    (e) => {
      try {
        if (onClick) {
          onClick(e);
        }
      } catch (error) {
        console.error(error);
      }
    },
    [onClick],
  );

  return (
    <button
      className={classNames(styles.container, className)}
      data-testid={dataTestId}
      onClick={onButtonClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default ModalButtonSecondary;
